

import Menu from './Menu';
import Home_banner from './Home_banner';
import About from './About';
import Menu_page from './Menu_page'
import Footer from './Footer';

const Home = () =>{
    
    return (
        <div>
            <Menu/>
            <Home_banner/>
            <About/>
            <Menu_page/>
            <Footer/>
        </div>
    );
};

export default Home; 


